export class UpdateRestoreTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreTemplate",
            "baseName": "restoreTemplate",
            "type": "RestoreTemplate",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRestoreTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
